import React from 'react';

import classNames from 'classnames';

import { ImageSize } from '@nxte-nl/image-hooks';

import { UrlType } from '../../types/apiEnums';
import { ImagePresentational, LinkPresentational } from '../../types/common';
import { Button, ButtonFit, ButtonIntent } from '../Button/Button';
import { DangerouslySetInnerHtml } from '../DangerouslySetInnerHtml/DangerouslySetInnerHtml';
import { ImageWithSize } from '../ImageWithSize/ImageWithSize';
import { Link, LinkType } from '../Link/Link';
import { Title } from '../Title/Title';
import styles from './ContentBlock.module.css';

export type Props = {
  body: string;
  className?: string;
  image?: ImagePresentational | null;
  isDesktop: boolean;
  link?: LinkPresentational | null;
  title: string;
};

export const ContentBlock = React.memo((props: Props) => {
  const {
    body,
    title,
    image,
    link,
    className,
    isDesktop,
  } = props;

  return (
    <div className={classNames(styles.contentBlock, className)}>
      {!isDesktop && link ? (
        <Link
          type={link.url.type === UrlType.ABSOLUTE ? LinkType.ExternalHref : LinkType.Href}
          to={link.url.href}
          withoutHoverStyles
        >
          <Button
            intent={ButtonIntent.secondary}
            fit={ButtonFit.Fill}
            isLink
          >
            {link.title}
          </Button>
        </Link>
      ) : null}

      {image
        ? <div className={styles.imageContainer}>
          <ImageWithSize
            image={image}
            size={ImageSize.XL}
          />
        </div>
        : null}

      <div className={styles.content}>
        <Title variant='h2' title={title} />

        <DangerouslySetInnerHtml
          variant={'body1'}
          className={styles.text}
          dangerousHtml={body}
        />

        {isDesktop && link ? (
          <Link
            type={link.url.type === UrlType.ABSOLUTE ? LinkType.ExternalHref : LinkType.Href}
            to={link.url.href}
            withoutHoverStyles
          >
            <Button
              intent={ButtonIntent.secondary}
              fit={ButtonFit.Inline}
              isLink
            >
              {link.title}
            </Button>
          </Link>
        ) : null}
      </div>
    </div>
  );
});

ContentBlock.displayName = 'ContentBlock';
